webpackJsonp([10991734084388],{

/***/ 76:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	__webpack_require__(106);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _scrollEvents = __webpack_require__(19);
	
	var _scrollEvents2 = _interopRequireDefault(_scrollEvents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FullImg = function (_React$Component) {
	  _inherits(FullImg, _React$Component);
	
	  function FullImg() {
	    _classCallCheck(this, FullImg);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  FullImg.prototype.componentDidMount = function componentDidMount() {
	    //   scrollEvents.add({
	    //     triggerSelector: '.full-img',
	    //     offset: '-50vh',
	    //     targets: [
	    //     {
	    //       targetSelector: '.img',
	    //       events: {
	    //         onTick: (el, dir, prog) => {
	    //           el.style.transform = `translateY(-${50*prog}px)`;
	    //         }
	    //       }
	    //     },
	    //     {
	    //       targetSelector: '.bg',
	    //       events: {
	    //         onTick: (el, dir, prog) => {
	    //           el.style.transform = `translateY(${75*prog}px)`;
	    //         }
	    //       }
	    //     }
	    //   ]
	    // })
	  };
	
	  FullImg.prototype.render = function render() {
	    var _props = this.props,
	        src = _props.src,
	        children = _props.children;
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'full-img', style: {
	          height: '530px',
	          marginBottom: '150px',
	          position: 'relative'
	        } },
	      _react2.default.createElement(
	        'div',
	        { className: 'bg', style: {
	            position: 'absolute',
	            top: 0,
	            left: 0,
	            width: '100%',
	            height: '100%',
	            background: 'url("/static/images/hatch-bg.png")',
	            zIndex: 0,
	            opacity: 1
	          } },
	        _react2.default.createElement('div', { style: {
	            background: '#A05925',
	            width: '100%',
	            height: '100%',
	            opacity: 0.9
	          } })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'row', style: {
	            position: 'relative',
	            display: 'block',
	            top: '75px',
	            width: '80%',
	            overflow: 'hidden',
	            height: '100%',
	            margin: '0 auto'
	          } },
	        children
	      )
	    );
	  };
	
	  return FullImg;
	}(_react2.default.Component);
	
	exports.default = FullImg;
	module.exports = exports['default'];

/***/ }),

/***/ 106:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 19:
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	  * Loop through a list of targets element and when element enters or leaves viewPort
	  * assign class names and fire event callbacks, if defined.
	**/
	
	var ENTERED_CLASS = 'scroll-entered',
	    LEFT_CLASS = 'scroll-left',
	    IN_VIEW_CLASS = 'scroll-in-view',
	    TRIGGERED_CLASS = 'scroll-triggered';
	
	function triggerScrollTargets() {
	  var targetConfigs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	  var direction = arguments[1];
	
	  for (var _iterator = targetConfigs, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
	    var _ref;
	
	    if (_isArray) {
	      if (_i >= _iterator.length) break;
	      _ref = _iterator[_i++];
	    } else {
	      _i = _iterator.next();
	      if (_i.done) break;
	      _ref = _i.value;
	    }
	
	    var configs = _ref;
	
	    for (var _iterator2 = configs.els, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
	      var _ref2;
	
	      if (_isArray2) {
	        if (_i2 >= _iterator2.length) break;
	        _ref2 = _iterator2[_i2++];
	      } else {
	        _i2 = _iterator2.next();
	        if (_i2.done) break;
	        _ref2 = _i2.value;
	      }
	
	      var el = _ref2;
	
	      var PREV_STATE = getPreviousState(el),
	          STATE = getCurrentState(el, configs, PREV_STATE);
	
	      triggerTargets(el, configs.targets || [configs], STATE, PREV_STATE, direction);
	    }
	  }
	}
	
	function triggerTargets(el, targetConfigs, state, prevState, direction) {
	  for (var _iterator3 = targetConfigs, _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : _iterator3[Symbol.iterator]();;) {
	    var _ref3;
	
	    if (_isArray3) {
	      if (_i3 >= _iterator3.length) break;
	      _ref3 = _iterator3[_i3++];
	    } else {
	      _i3 = _iterator3.next();
	      if (_i3.done) break;
	      _ref3 = _i3.value;
	    }
	
	    var configs = _ref3;
	
	    var target = el.querySelector(configs.targetSelector || configs.triggerSelector);
	    triggerTarget(el, target, configs.events, state, prevState, direction);
	  }
	}
	
	function triggerTarget(el, target) {
	  var events = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	  var state = arguments[3];
	  var prevState = arguments[4];
	  var direction = arguments[5];
	  var ENTERING = state.ENTERING,
	      ENTERED = state.ENTERED,
	      IN_VIEW = state.IN_VIEW,
	      TRIGGERED = state.TRIGGERED,
	      LEAVING = state.LEAVING,
	      LEFT = state.LEFT,
	      progress = state.progress;
	
	
	  if (IN_VIEW && events.onTick) events.onTick(target, direction, progress);else if (LEFT && events.onTick) events.onTick(target, direction, 1);else if (events.onTick) events.onTick(target, direction, 0);
	
	  if (ENTERING && events.onEnter) events.onEnter(target, direction);
	  if (LEAVING && events.onLeave) events.onLeave(target, direction);
	
	  toggleClass(el, ENTERED_CLASS, ENTERED);
	  toggleClass(el, LEFT_CLASS, LEFT);
	  toggleClass(el, IN_VIEW_CLASS, IN_VIEW);
	  toggleClass(el, TRIGGERED_CLASS, TRIGGERED && !prevState.TRIGGERED, false);
	}
	
	function toggleClass(target, className, toggleOn, toggleOff) {
	  if (toggleOn) target.classList.add(className);else if (toggleOff !== false) target.classList.remove(className);
	}
	
	function getPreviousState(el) {
	  return {
	    ENTERED: el.classList.contains(ENTERED_CLASS),
	    LEFT: el.classList.contains(LEFT_CLASS),
	    IN_VIEW: el.classList.contains(IN_VIEW_CLASS),
	    TRIGGERED: el.classList.contains(TRIGGERED_CLASS)
	  };
	}
	
	function getCurrentState(el, configs, prevState) {
	  var rect = el.getBoundingClientRect();
	
	  var _getOffsets = getOffsets(el, configs),
	      offset = _getOffsets.offset,
	      topOffset = _getOffsets.topOffset,
	      bottomOffset = _getOffsets.bottomOffset,
	      triggerPointOffset = _getOffsets.triggerPointOffset;
	
	  var entered = rect.top + topOffset + triggerPointOffset <= 0,
	      left = -rect.top > el.offsetHeight + bottomOffset + triggerPointOffset,
	      progress = 1 - (rect.top + triggerPointOffset + el.offsetHeight + bottomOffset - 0.5) / (el.offsetHeight - topOffset + bottomOffset);
	
	  return {
	    ENTERING: entered && !left && (!prevState.ENTERED || prevState.LEFT),
	    ENTERED: entered,
	    TRIGGERED: prevState.TRIGGERED || entered,
	    IN_VIEW: entered && !left,
	    LEAVING: (left || !entered) && prevState.IN_VIEW,
	    LEFT: left,
	    progress: progress
	  };
	}
	
	function getOffsets(el, configs) {
	  return {
	    offset: getOffset(el, el.getAttribute('data-scroll-offset') || configs.offset || 0),
	    topOffset: getOffset(el, el.getAttribute('data-scroll-top-offset') || configs.offset || configs.topOffset || 0),
	    bottomOffset: getOffset(el, el.getAttribute('data-scroll-bottom-offset') || configs.offset || configs.bottomOffset || 0),
	    triggerPointOffset: getTriggerPointOffset(el.getAttribute('data-scroll-trigger-point') || configs.triggerPoint || 'top')
	  };
	}
	
	function getOffset(el, offset) {
	  if (typeof offset === 'number') return offset;
	  if (!offset) return false;
	  if (offset.indexOf('%') !== -1) return el.offsetHeight * offset.replace('%', '') / 100;
	  if (offset.indexOf('vh') !== -1) {
	    return getDocHeight() * offset.replace('vh', '') / 100;
	  }
	
	  return +offset;
	}
	
	function getTriggerPointOffset(triggerPoint) {
	  switch (triggerPoint) {
	    case 'top':
	      return 0;
	    case 'bottom':
	      return -getDocHeight();
	    case 'middle':
	      return -getDocheight() / 2;
	    default:
	      return 0;
	  }
	}
	
	function getDocHeight() {
	  return Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
	}
	
	var ScrollTargets = exports.ScrollTargets = function ScrollTargets() {
	  var _this = this;
	
	  _classCallCheck(this, ScrollTargets);
	
	  this.init = function () {
	    // default scroll selector
	    _this.add({ triggerSelector: '.scroll-target' });
	    // first tick;
	    _this.triggerScrollTargets();
	
	    window.addEventListener('scroll', _this.scroll, true);
	    window.addEventListener('touchmove', _this.scroll, true);
	  };
	
	  this.scroll = function () {
	    window.requestAnimationFrame(_this.triggerScrollTargets);
	  };
	
	  this.triggerScrollTargets = function () {
	    _this.position = window.scrollY || window.pageYOffset;
	
	    if (_this.position === _this.prevPosition) _this.direction = _this.prevDirection;else _this.direction = _this.position < _this.prevPosition ? 'REVERSE' : 'FORWARD';
	
	    triggerScrollTargets(_this.targets, _this.direction);
	
	    _this.prevPosition = _this.position;
	    _this.prevDirection = _this.direction;
	  };
	
	  this.add = function (target) {
	    var els = document.querySelectorAll(target.triggerSelector);
	    _this.targets = [].concat(_this.targets, [_extends({}, target, { els: els })]);
	
	    return _this;
	  };
	
	  this.reload = function () {
	    var targets = [];
	    for (var _iterator4 = _this.targets, _isArray4 = Array.isArray(_iterator4), _i4 = 0, _iterator4 = _isArray4 ? _iterator4 : _iterator4[Symbol.iterator]();;) {
	      var _ref4;
	
	      if (_isArray4) {
	        if (_i4 >= _iterator4.length) break;
	        _ref4 = _iterator4[_i4++];
	      } else {
	        _i4 = _iterator4.next();
	        if (_i4.done) break;
	        _ref4 = _i4.value;
	      }
	
	      var t = _ref4;
	
	      targets.push(_extends({}, t, { els: document.querySelectorAll(t.selector) }));
	    }_this.targets = targets;
	
	    return _this;
	  };
	
	  this.clear = function () {
	    _this.targets = [];
	    _this.direction = 'START';
	
	    return _this;
	  };
	
	  this.events = [];
	  this.prevPosition = 0;
	  this.direction = 'START';
	  this.prevDirection = 'START';
	  this.position = 0;
	  this.animationFrame = 0;
	  this.targets = [];
	}
	
	/**
	  *
	  * @typedef {Object} Target
	  * @property {string} triggerSelector - (required) document.querySelectorAll compatable string. Elements that will trigger events,
	  * @property {string} targetSelector - (default: triggerSelector) class selector for a single element. must be child of triggerSelector. the element to apply scroll classes / event callbacks to,
	  * @property {Target[]} targets - add multiple target events, takes targetSelector and events properties,
	  * @property {string} triggerPoint - (default: 'top', options: 'top', 'middle', 'bottom') part of viewPort event is triggered,
	  * @property {(number|string)} offset - (default: 0) offset for both enter and leave events. essentially shifts entire frame by this valut. if defined as % (eg '50%'), offsets by % of element's outerHeight,
	  * @property {(number|string)} topOffset - (default: 0) offset from triggerPoint for enter events. if defined as % (eg '50%'), offsets by % of element's outerHeight,
	  * @property {(number|string)} bottomOffset - (default: 0) offset from triggerPoint for leave events. If defined as %, (eg '50%'), offsets by % of element's outerHeight,
	  * @property {object} events - event callbacks
	  * @property {eventCallback} events.onEnter - event for the exact moment when element hits the triggerPoint,
	  * @property {eventCallback} events.onLeave - event for the exact moment when element (including outerHeight) goes outside the triggerPoint
	  * @property {eventCallback} events.onTick - when element is in view, event fires for each scroll tick. Also gives % scroll progress param as decimal.
	  *
	  * @callback eventCallback
	  * @param {HtmlElement} el - the triggered html target element
	  * @param {string} direction - the direction scroll is moving ('FORWARD' or 'REVERSE')
	  * @param {number} progress - for onTick callback. percent progress for selector
	  *
	**/
	
	;
	
	var scrollEvents = new ScrollTargets();
	
	exports.default = scrollEvents;
	
	
	function getOffset(el, offset) {
	  if (typeof offset === 'number') return offset;
	  if (!offset) return false;
	  if (offset.indexOf('%') !== -1) return el.offsetHeight * offset.replace('%', '') / 100;
	  if (offset.indexOf('vh') !== -1) {
	    var docHeight = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
	    return docHeight * offset.replace('vh', '') / 100;
	  }
	
	  return +offset;
	}
	
	function getTriggerPointOffset(triggerPoint, docHeight) {
	  switch (triggerPoint) {
	    case 'top':
	      return 0;
	    case 'bottom':
	      return -docHeight;
	    case 'middle':
	      return -docHeight / 2;
	    default:
	      return 0;
	  }
	}

/***/ }),

/***/ 206:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	__webpack_require__(347);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(25);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _fullImg = __webpack_require__(76);
	
	var _fullImg2 = _interopRequireDefault(_fullImg);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PersonCard = function (_React$Component) {
	  _inherits(PersonCard, _React$Component);
	
	  function PersonCard(props) {
	    _classCallCheck(this, PersonCard);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.mouseOver = function () {
	      if (_this.state.expanded) return;
	      _this.setState({
	        hoverImg: { transform: 'translate(25px, 10px)' },
	        hoverBg: { transform: 'translate(10px, -10px)' }
	      });
	    };
	
	    _this.mouseOut = function () {
	      if (_this.state.expanded) return;
	      _this.setState({
	        hoverImg: {},
	        hoverBg: {}
	      });
	    };
	
	    _this.click = function () {
	      if (!_this.state.expanded) {
	        _this.props.switchPerson(_this.props.src);
	        return _this.setState({
	          expandWrapper: {
	            width: '100%',
	            height: '325px',
	            zIndex: 1
	          },
	          expandImg: {
	            transform: 'translate(25px,45px)'
	          },
	          expandBg: {
	            width: '100%',
	            height: '100%',
	            transform: 'translate(0,-50px)'
	          },
	          hoverImg: {},
	          hoverBg: {},
	          expanded: true
	        });
	      }
	
	      _this.props.switchPerson(false);
	      _this.setState({
	        expandWrapper: {},
	        expandImg: {},
	        expandBg: {},
	        expanded: false
	      });
	    };
	
	    _this.state = {
	      hoverImg: {},
	      hoverBg: {},
	      expanded: false,
	      expandWrapper: {},
	      expandBg: {},
	      expandImg: {}
	    };
	    return _this;
	  }
	
	  PersonCard.prototype.render = function render() {
	    var _props = this.props,
	        src = _props.src,
	        style = _props.style,
	        name = _props.name,
	        tag = _props.tag,
	        attrs = _props.attrs;
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'person-card ' + (this.state.expanded ? 'expanded' : ''), style: _extends({}, style, {
	          top: 0,
	          //left: 0,
	          //transform: 'translate(0,0)',
	          transition: 'all ease 0.35s',
	          width: '240px',
	          height: '360px',
	          cursor: 'pointer',
	          zIndex: 0
	        }, this.state.expandWrapper),
	        onClick: this.click,
	        onMouseOver: this.mouseOver,
	        onMouseOut: this.mouseOut
	      },
	      _react2.default.createElement(
	        'div',
	        { style: _extends({
	            width: '240px',
	            height: '360px',
	            transform: 'translate(0,0)',
	            background: '#F9A781',
	            position: 'absolute',
	            transition: 'all ease 0.35s',
	            overflow: 'hidden',
	            left: 0,
	            bottom: 0
	          }, this.state.hoverBg, this.state.expandBg) },
	        _react2.default.createElement(
	          'div',
	          { className: 'person-card__text', style: {
	              position: 'absolute',
	              width: 'calc(100% - 275px)',
	              left: '275px',
	              transition: 'opacity 0.35s ease',
	              visibility: this.state.expanded ? 'visible' : 'hidden',
	              opacity: this.state.expanded ? 1 : 0,
	              transitionDelay: '0.4s'
	            } },
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-lg-5 person-card__name', style: { paddingLeft: '50px', position: 'relative', height: '325px' } },
	              _react2.default.createElement(
	                'div',
	                { style: { position: 'absolute', top: '50%', transform: 'translateY(-50%)' } },
	                _react2.default.createElement(
	                  'h2',
	                  { style: {
	                      color: '#fff',
	                      letterSpacing: '0.075em',
	                      fontSize: '36px',
	                      fontFamily: 'Futura',
	                      marginBottom: '15px'
	                    } },
	                  name
	                ),
	                _react2.default.createElement(
	                  'p',
	                  { style: {
	                      color: '#fff',
	                      fontFamily: 'Futura',
	                      fontWeight: 200,
	                      marginBottom: 0
	                    } },
	                  tag
	                ),
	                _react2.default.createElement(
	                  'p',
	                  { style: {
	                      color: '#fff',
	                      fontFamily: 'Futura',
	                      fontWeight: 200,
	                      fontSize: '11px',
	                      margin: 0
	                    } },
	                  '(she/her/hers)'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-lg-7 person-card__superpowers', style: { background: 'rgba(75,75,75,0.15)', paddingTop: '35px', height: '325px', position: 'relative' } },
	              _react2.default.createElement(
	                'div',
	                { className: 'person-card__superpowers__text' },
	                _react2.default.createElement(
	                  'div',
	                  { style: { marginBottom: '10px' } },
	                  _react2.default.createElement('img', { src: '/static/images/icons/lightning.svg', style: { width: '15px', height: 'auto', display: 'inline-block', verticalAlign: 'middle' } }),
	                  _react2.default.createElement(
	                    'h3',
	                    { style: { color: 'white', fontFamily: 'Futura', fontSize: '18px', fontWeight: 200, letterSpacing: '0.05em', marginLeft: '10px', display: 'inline-block', verticalAlign: 'middle' } },
	                    'Super powers include:'
	                  )
	                ),
	                attrs.map(function (a, i) {
	                  return _react2.default.createElement(
	                    'div',
	                    { key: 'attr-' + i, className: 'person-card__attr', style: {
	                        display: 'inline-block',
	                        width: '50%',
	                        height: '75px',
	                        verticalAlign: 'top',
	                        marginBottom: '35px',
	                        paddingLeft: '10px',
	                        paddingRight: '15px'
	                      } },
	                    _react2.default.createElement(
	                      'h3',
	                      { style: {
	                          color: '#fff',
	                          position: 'relative',
	                          fontFamily: 'Futura',
	                          fontSize: '12px',
	                          letterSpacing: '0.1em',
	                          margin: 0,
	                          marginLeft: '15px',
	                          marginBottom: '10px',
	                          lineHeight: '1.25em',
	                          textTransform: 'uppercase'
	                        } },
	                      _react2.default.createElement(
	                        'span',
	                        { style: { position: 'absolute', left: '-15px' } },
	                        '\u2022'
	                      ),
	                      a.title
	                    ),
	                    _react2.default.createElement(
	                      'p',
	                      { style: {
	                          color: '#fff',
	                          fontFamily: 'Futura',
	                          marginLeft: '15px',
	                          fontWeight: 200,
	                          lineHeight: '1.3em',
	                          fontSize: '14px'
	                        } },
	                      a.desc
	                    )
	                  );
	                })
	              )
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'person-card__img', style: _extends({
	            width: '240px',
	            height: '360px',
	            overflow: 'hidden',
	            position: 'absolute',
	            transform: 'translate(50px,0)',
	            transition: 'all ease 0.2s',
	            bottom: '35px'
	          }, this.state.hoverImg, this.state.expandImg) },
	        _react2.default.createElement('img', { src: src, style: {
	            height: '100%',
	            width: 'auto',
	            maxWidth: 'none',
	            margin: 0
	          } })
	      )
	    );
	  };
	
	  return PersonCard;
	}(_react2.default.Component);
	
	var About = function About() {
	  return _react2.default.createElement(
	    'div',
	    { id: 'services-about', style: {
	        padding: '0 0 90px 0',
	        position: 'relative'
	      } },
	    _react2.default.createElement(
	      'div',
	      { style: {
	          width: '100%',
	          maxWidth: '800px',
	          padding: '0 10px',
	          margin: '0px auto'
	        } },
	      _react2.default.createElement(
	        'h1',
	        { style: {
	            marginBottom: '50px'
	          } },
	        _react2.default.createElement(
	          'span',
	          null,
	          _react2.default.createElement(
	            'span',
	            null,
	            'About Nicole'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { style: {
	            fontFamily: 'Futura',
	            fontWeight: 200,
	            lineHeight: '35px',
	            fontSize: '24px',
	            color: '#7f7f7f'
	          } },
	        _react2.default.createElement(
	          'p',
	          null,
	          'Nicole Newman is a writer, passionate advocate and one of the co-founders of Two Brown Girls Consulting Cooperative.'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Nicole learned how to organize from her aunt and grandparents who at an early age exposed her to community action by those most impacted coming together for collective action. She was taught by her mother to ask as many questions as satisfied her curiosity. She is a graduate of Trinity University Washington DC with a degree in political science and is currently working on her Masters in Organizational Development from American University. She is an Americorps Vista Alum and has spent her professional career providing direct services to women experiencing homelessness, volunteer management and later on building coalitions and doing education and housing advocacy and organizing.'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'With the co-founding of Two Brown Girls, Nicole wants to help create more equitable people focused organizations via training and conversation around racial equity and inclusion; community organizing and client engagement; advocacy; strategic growth and planning and navigating change and conflict.'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'In addition to Two Brown Girls, Nicole does coaching and youth development work. She likes traveling (mostly with Aja) and sunflowers, unicorns, the enneagram and being in nature. Nicole is a dreamer at heart and you can often catch her mediating and sitting in silence.'
	        )
	      ),
	      _react2.default.createElement(
	        'h1',
	        { style: {
	            marginBottom: '50px',
	            marginTop: '50px'
	          } },
	        _react2.default.createElement(
	          'span',
	          null,
	          _react2.default.createElement(
	            'span',
	            null,
	            'About Aja'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { style: {
	            fontFamily: 'Futura',
	            fontWeight: 200,
	            lineHeight: '35px',
	            fontSize: '24px',
	            color: '#7f7f7f'
	          } },
	        _react2.default.createElement(
	          'p',
	          null,
	          'Aja Taylor is a community organizer, master facilitator and one of the co-founders of Two Brown Girls Consulting Cooperative.'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'She comes to this work as a young Black woman raised by socially conscious parents who always pushed their children to not just examine, but also challenge oppressive systems. Aja has been organizing since 14, where she organized young people and adult allies around the deplorable conditions at Oak Hill Juvenile Detention Facility in DC. Since then, her professional work has been with countless community organizations, coalitions and nonprofits to not just mobilize impacted people around critical public policies, but to intentionally develop the leadership infrastructure in ways that allow said communities to continue to put pressure on systems and challenge the status quo in ways that build their collective power.'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'With Two Brown Girls Consulting Cooperative, Aja is excited to use the knowledge, skills and expertise she has gained as a grassroots organizer and mobilizer to help nonprofit, mission-driven and movement organizations deepen their relationship to their base and their work, create effective strategies to move their work forward, and also to build the capacity of organizations seeking to be be actively anti-racist\u2014working with communities in ways that honor their salient knowledge and build their collective power.'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'In addition to co-leading Two Brown Girls Consulting Cooperative, Aja also does political education workshops, community organizing curriculum development, and keynotes. She enjoys traveling anywhere with sand and blue water, and cooks the best seafood gumbo this side of the Mississippi.'
	        ),
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '/services', className: 'button', style: { marginTop: '50px', display: 'inline-block' } },
	          'Our Services'
	        )
	      )
	    )
	  );
	};
	
	var AboutPage = function (_React$Component2) {
	  _inherits(AboutPage, _React$Component2);
	
	  function AboutPage(props) {
	    _classCallCheck(this, AboutPage);
	
	    var _this2 = _possibleConstructorReturn(this, _React$Component2.call(this, props));
	
	    _this2.switchPerson = function (img) {
	      _this2.setState({ active: img });
	    };
	
	    _this2.state = {
	      active: false
	    };
	    return _this2;
	  }
	
	  AboutPage.prototype.render = function render() {
	    var active = this.state.active;
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'div',
	        { className: 'container', style: { marginTop: '90px', maxWidth: '740px', textAlign: 'center' } },
	        _react2.default.createElement(
	          'h1',
	          { style: { marginBottom: '50px' } },
	          _react2.default.createElement(
	            'span',
	            null,
	            _react2.default.createElement(
	              'span',
	              null,
	              'Meet Aja &'
	            )
	          ),
	          _react2.default.createElement(
	            'span',
	            null,
	            _react2.default.createElement(
	              'span',
	              null,
	              '\xA0Nicole'
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'container person-cards', style: { position: 'relative', height: '360px', margin: '50px auto 175px auto' } },
	        _react2.default.createElement(PersonCard, { src: '/static/images/nicole-headshot-2.min.jpg', switchPerson: this.switchPerson,
	          name: 'Nicole Newman',
	          tag: 'co\xA0-\xA0conspirator | facilitator',
	          attrs: [{ title: 'Ideation', desc: 'quickly able to brainstorm and develop ideas' }, { title: 'Moving through Conflict', desc: 'comfort with and ability to lead through conflict' }, { title: 'Intuition', desc: 'strong intuition and ability to read situations' }, { title: 'Coaching', desc: 'experienced facilitator and coach' }],
	          style: {
	            opacity: active == '/static/images/nicole-headshot-2.min.jpg' || active === false ? 1 : 0
	          } }),
	        _react2.default.createElement(PersonCard, { src: '/static/images/aja-headshot-2.min.jpg', switchPerson: this.switchPerson,
	          name: 'Aja Taylor',
	          tag: 'co\xA0-\xA0conspirator | facilitator',
	          attrs: [{ title: 'Big Picture Thinker', desc: 'long term invisioning and implementation wizard' }, { title: 'Cutting to the Chase', desc: 'helping groups cut through the noise and have the right conversations' }, { title: 'Synthesis', desc: 'distilling long discussions into salient points and themes (code name: the sensei of summary)' }, { title: 'Reflection', desc: 'asking questions that encourage critical reflection and truth telling (even when it’s hard)' }],
	          style: {
	            opacity: active == '/static/images/aja-headshot-2.min.jpg' || active === false ? 1 : 0
	          } })
	      ),
	      _react2.default.createElement(
	        _fullImg2.default,
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'col-8', style: { height: '500px', overflow: 'hidden' } },
	          _react2.default.createElement('img', { src: '/static/images/meeting-laughing.jpg', style: { width: 'auto', height: '100%', display: 'block' } })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'col-4', style: { height: '500px', overflow: 'hidden' } },
	          _react2.default.createElement('img', { src: '/static/images/nicole-explains.jpg', style: { width: 'auto', marginBottom: '15px', height: '242.5px', display: 'block' } }),
	          _react2.default.createElement('img', { src: '/static/images/aja-explains.jpg', style: { width: 'auto', margin: 0, height: '242.5px', display: 'block' } })
	        )
	      ),
	      _react2.default.createElement(About, null)
	    );
	  };
	
	  return AboutPage;
	}(_react2.default.Component);
	
	exports.default = AboutPage;
	module.exports = exports['default'];

/***/ }),

/***/ 347:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-about-index-js-a8eef9706becb7c1164c.js